import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sba-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrls: ['./privacy-notice.component.scss']
})
export class PrivacyNoticeComponent {}
